<template>
  <div>
    <b-form-group>
      <label for="id">
        {{ label }}
        <span v-if="isRequired" class="text-danger">*</span>
      </label>
      <b-form-select
        v-model="value.$model"
        type="text"
        :id="id"
        :state="value.$dirty ? !value.$error : null"
        aria-describedby="phoneNumber-live-feedback"
        :options="options"
      ></b-form-select>
      <b-form-invalid-feedback :id="id + '-live-feedback'">{{ feedback }}</b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'select-input',
  props: {
    value: {
      default: null,
      required: true,
    },
    id: {
      default: null,
      required: true,
    },
    feedback: {
      default: null,
      required: true,
    },
    label: {
      default: null,
      required: true,
    },
    isRequired: {
      default: false,
      required: false,
    },
    options: {
      default: null,
      required: true
    }
  }
}
</script>